import { Link } from 'react-router-dom'
import { usePublicPosts } from '../hooks/usePosts'
import { estimateReadTime } from '../lib/helpers'

export default function BlogPreviewSection() {
  const { posts, loading } = usePublicPosts(3)

  if (!loading && posts.length === 0) return null

  return (
    <section className="section">
      <div className="section-inner">
        <div className="cases-header">
          <div>
            <div className="section-eyebrow">Blog</div>
            <h2 className="section-title" style={{ marginBottom: 0 }}>Artigos e insights</h2>
          </div>
          <Link to="/blog" className="btn-ghost">Ver todos os artigos</Link>
        </div>

        <div className="cases-grid">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.id} style={{ textDecoration: 'none' }}>
              <article className="blog-card">
                {p.cover_image_url && (
                  <img
                    src={p.cover_image_url}
                    alt={p.title}
                    style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 12, marginBottom: 16 }}
                  />
                )}
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
                  {p.title}
                </h3>
                <p style={{ fontSize: 14, color: 'var(--text-dim)', lineHeight: 1.65, marginBottom: 16 }}>{p.excerpt}</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                  <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                    {p.published_at ? new Date(p.published_at).toLocaleDateString('pt-BR') : new Date(p.created_at).toLocaleDateString('pt-BR')}
                    {' · '}{estimateReadTime(p.content)} min
                  </span>
                  {(p.tags || []).map((t) => <span className="case-tag" key={t}>{t}</span>)}
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
